import type { ModalUICopy, ScreenUICopy } from '@polyai/ui/uiCopy/types';

export type SpeechRecognitionScreenUICopy = ScreenUICopy<string, string> & {
  tabs: {
    keyphraseBoosting: string;
    transcriptCorrections: string;
  };
  transcriptCorrections: {
    button: {
      add: string;
    };
    empty: {
      title: string;
      description: string;
    };
    card: {
      description: string;
      name: string;
      popupMenu: {
        edit: string;
        delete: string;
      };
      modal: {
        delete: Omit<ModalUICopy<string, string>, 'button' | 'description'>;
      };
      inactiveTooltip: string;
    };
  };
  keyphraseBoosting: {
    title: string;
    helpText: string;
    inputText: string;
    inputTextPlaceholder: string;
    helperTextMap: {
      default: string;
      boosted: string;
      maximum: string;
    };
    deleteToast: {
      title: string;
      description: string;
    };
  };
};

export enum SpeechRecognition {
  KEYPHRASE_BOOSTING = 'keyphrase-boosting',
  TRANSCRIPT_CORRECTIONS = 'transcript-corrections',
}
